import PageShell from "../../../layout/PageShell";
import useAccountId, {
  useBreadcrumbsWithCustomDomain,
} from "../../../hooks/customDomainHooks";
import EnpsReport from "./EnpsReport";

const EnpsReportPage = () => {
  const { accountId } = useAccountId();
  const breadcrumbs = useBreadcrumbsWithCustomDomain([
    { type: "HOME", href: `/${accountId}/home` },
    { name: "Reports", href: `/${accountId}/reports` },
    { name: "eNPS" },
  ]);

  return (
    <PageShell breadcrumbs={breadcrumbs}>
      <EnpsReport />
    </PageShell>
  );
};

export default EnpsReportPage;
